import { WebinarBannerBlock } from 'src/types/articleCmsTypes';
import { Button } from 'src/uikit/Button';

import s from './WebinarBanner.module.scss';

export function WebinarBanner({
  title,
  time,
  description,
  button,
}: Omit<WebinarBannerBlock, 'type'>) {
  return (
    <div className={s.root}>
      <h2 className={s.title}>{title}</h2>
      <p className={s.time}>{time}</p>
      <p className={s.desc}>{description}</p>

      <Button
        link={button.url}
        analyticsOptions={{
          action: button.url,
          clickZone: 'body',
          clickElement: 'button',
          clickContent: button.text,
          uniqueId: `webinar-banner-blog-${button.text}`,
          transitionType: 'inside-link',
        }}
      >
        {button.text}
      </Button>
    </div>
  );
}
